function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Ellipse_38",
  x: 9.095,
  y: 12.384,
  width: 30.768,
  height: 30.768,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.78
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "Ellipse_38-2",
  x: 20.82,
  y: 0,
  width: 30.768,
  height: 30.768,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  result: "blur-2"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.78
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur-2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "Ellipse_38-3",
  x: 31.656,
  y: 13.333,
  width: 30.768,
  height: 30.768,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  result: "blur-3"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.78
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur-3"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Component_306_1",
  "data-name": "Component 306 \\u2013 1",
  transform: "translate(0.509 0.452)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-hands",
  "data-name": "Icon awesome-hands",
  d: "M22.292,18.112a3.483,3.483,0,0,0-5.573,4.18l4.147,5.529A1.74,1.74,0,0,1,20.7,30.1l-1.393,1.393a1.731,1.731,0,0,1-2.569-.12L6.966,19.636V3.483A3.483,3.483,0,0,0,0,3.483V27.255A5.23,5.23,0,0,0,1.143,30.52L12.474,45.138A6.5,6.5,0,0,1,13.606,47.5a1.705,1.705,0,0,0,1.665,1.263H29.606a1.747,1.747,0,0,0,1.742-1.742V34.83a13.954,13.954,0,0,0-2.786-8.359ZM66.178,0A3.479,3.479,0,0,0,62.7,3.483V19.636L52.921,31.369a1.748,1.748,0,0,1-2.569.12L48.959,30.1a1.74,1.74,0,0,1-.163-2.275l4.147-5.529a3.483,3.483,0,0,0-5.573-4.18L41.1,26.471a13.954,13.954,0,0,0-2.786,8.359V47.021a1.747,1.747,0,0,0,1.742,1.742H54.39A1.715,1.715,0,0,0,56.056,47.5a6.5,6.5,0,0,1,1.132-2.362L68.518,30.52a5.23,5.23,0,0,0,1.143-3.265V3.483A3.479,3.479,0,0,0,66.178,0Z",
  transform: "translate(0 23.832) rotate(-1)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1691",
  "data-name": "Group 1691",
  transform: "translate(11.586)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1688",
  "data-name": "Group 1688",
  transform: "translate(0 12.384)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, -12.09, -12.84)",
  filter: "url(#Ellipse_38)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_38-4",
  "data-name": "Ellipse 38",
  transform: "translate(12.09 14.38)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.384,
  cy: 12.384,
  rx: 12.384,
  ry: 12.384,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.384,
  cy: 12.384,
  rx: 11.884,
  ry: 11.884,
  fill: "none"
}))), /*#__PURE__*/React.createElement("text", {
  id: "_",
  "data-name": "$",
  transform: "translate(7.74 19)",
  fill: "#707070",
  fontSize: 18,
  fontFamily: "FiraSans-Bold, Fira Sans",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "$"))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1689",
  "data-name": "Group 1689",
  transform: "translate(11.725 0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, -23.82, -0.45)",
  filter: "url(#Ellipse_38-2)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_38-5",
  "data-name": "Ellipse 38",
  transform: "translate(23.82 2)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.384,
  cy: 12.384,
  rx: 12.384,
  ry: 12.384,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.384,
  cy: 12.384,
  rx: 11.884,
  ry: 11.884,
  fill: "none"
}))), /*#__PURE__*/React.createElement("text", {
  id: "_2",
  "data-name": "$",
  transform: "translate(7.74 19)",
  fill: "#707070",
  fontSize: 18,
  fontFamily: "FiraSans-Bold, Fira Sans",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "$"))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1690",
  "data-name": "Group 1690",
  transform: "translate(22.561 13.333)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, -34.66, -13.79)",
  filter: "url(#Ellipse_38-3)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_38-6",
  "data-name": "Ellipse 38",
  transform: "translate(34.66 15.33)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.384,
  cy: 12.384,
  rx: 12.384,
  ry: 12.384,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.384,
  cy: 12.384,
  rx: 11.884,
  ry: 11.884,
  fill: "none"
}))), /*#__PURE__*/React.createElement("text", {
  id: "_3",
  "data-name": "$",
  transform: "translate(7.74 19)",
  fill: "#707070",
  fontSize: 18,
  fontFamily: "FiraSans-Bold, Fira Sans",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "$")))));

function SvgAllInclude(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71.519,
    height: 73.548,
    viewBox: "0 0 71.519 73.548",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllInclude);
export default __webpack_public_path__ + "static/media/all_include.d7cb99d8c4691e001cd0a3ce159e86a7.svg";
export { ForwardRef as ReactComponent };